import { AlertController, AlertOptions } from '@ionic/angular';

/** Use this if you need to prompt an alert depending on a "hasChanges" logic.
 * ie: User wanna leave a modal with a dirty form. You just have to pass canDimiss to the modalController.create and updateHasChanges as an Input which you will update with a form.valueChanges.
 *
 *
 * ```
   const modal = await this.modalCtrl.create({
      component: AccountInfosModalComponent,
      componentProps: {
        updateHasChanges: dimiss.updateHasChanges,
      },
      canDismiss: dimiss.canDismiss,
    });
```

Then in the modal ngOnInit:
```
    if (this.updateHasChanges) this.form.valueChanges.subscribe((_value) => this.updateHasChanges!(this.form!.dirty));

```

Don't forget to set changes to false if you stay on the modal after submitting a form :
```
this.updateHasChanges(false);
```

And you're done
 *
 *
 */
export const dismissFactory = (alertCtrl: AlertController, alertOpts: AlertOptions) => {
  let hasChanges = false;
  const updateHasChanges = (value: boolean) => (hasChanges = value);

  const canDismiss = async () => {
    if (hasChanges) {
      const alert = await alertCtrl.create(alertOpts);

      await alert.present();
      if ((await alert.onWillDismiss())?.role !== 'confirm') {
        return false;
      }
    }

    return true;
  };

  return { canDismiss, updateHasChanges };
};
